// config/cacheConfig.js - Cache configuration constants

/**
 * Time-To-Live (TTL) values for different data types in milliseconds
 * These control how long cached data remains valid before expiring
 */
export const CACHE_TTL = {
  /** Role data - 15 minutes (rarely changes) */
  roles: 15 * 60 * 1000,

  /** Member data - 10 minutes (moderate change frequency) */
  members: 10 * 60 * 1000,

  /** Division data - 15 minutes (rarely changes) */
  divisions: 15 * 60 * 1000,

  /** Group/Team data - 10 minutes (moderate change frequency) */
  groups: 10 * 60 * 1000,

  /** Invitation data - 3 minutes (high change frequency) */
  invitations: 3 * 60 * 1000,

  /** Organization data - 30 minutes (very stable) */
  organization: 30 * 60 * 1000,

  /** Notification data - 2 minutes (high change frequency) */
  notifications: 2 * 60 * 1000
};

/**
 * Maximum number of cache entries across all data types
 * Used to prevent unbounded cache growth
 */
export const CACHE_SIZE_LIMIT = 500;

/**
 * Cache storage keys for localStorage persistence
 */
export const CACHE_STORAGE_KEYS = {
  CACHE_DATA: 'organizationCache',
  CACHE_EXPIRY: 'organizationCacheExpiry'
};

/**
 * Default values for cache configuration
 */
export const CACHE_DEFAULTS = {
  /** Default TTL if no specific TTL is defined for a data type (5 minutes) */
  DEFAULT_TTL: 5 * 60 * 1000,

  /** Enable localStorage persistence */
  PERSIST_TO_STORAGE: true,

  /** Enable cache event dispatching */
  ENABLE_EVENTS: true
};
